export default {"src":"/_next/static/media/discount.73b16a69.svg","height":23,"width":18,"blurWidth":0,"blurHeight":0};